module.exports = __webpack_public_path__ + "97fd042386b37f4313d76a79821af5b1.png";